import React, { useMemo } from "react";

import { useStoredData } from "@/store";
import { SupText } from "@repo/core-ui";

export default function Web3TxSettingsSlippageWarning() {
  const storedData = useStoredData();

  const showWarning = useMemo(() => {
    return storedData.txSettings.bridgeSlippage > 500 || storedData.txSettings.dexSlippage > 500;
  }, [storedData.txSettings.bridgeSlippage, storedData.txSettings.dexSlippage]);

  return (
    showWarning && (
      <div className="bg-warning-50 px-4 py-2">
        <SupText variant="subtitle2" className="text-warning-900">
          Your slippage is high. Your transaction may be frontrun.
        </SupText>
      </div>
    )
  );
}
